import { ValidationsErrorsCatalogData } from '@repo/core'
import { generateCatalogSlice } from '../generators'

export const { actions: commonValidationsErrorsActions, reducer: commonValidationsErrorsReducers } =
  generateCatalogSlice<ValidationsErrorsCatalogData>({
    domain: 'common',
    namespace: 'validationsErrors',
  })

export const {
  actions: accountsValidationsErrorsActions,
  reducer: accountsValidationsErrorsReducers,
} = generateCatalogSlice<ValidationsErrorsCatalogData>({
  domain: 'accounts',
  namespace: 'validationsErrors',
})

export const {
  actions: positionValidationsErrorsActions,
  reducer: positionValidationsErrorsReducers,
} = generateCatalogSlice<ValidationsErrorsCatalogData>({
  domain: 'position',
  namespace: 'validationsErrors',
})

export const { actions: toolsValidationsErrorsActions, reducer: toolsValidationsErrorsReducers } =
  generateCatalogSlice<ValidationsErrorsCatalogData>({
    domain: 'tools',
    namespace: 'validationsErrors',
  })

export const { actions: userValidationsErrorsActions, reducer: userValidationsErrorsReducers } =
  generateCatalogSlice<ValidationsErrorsCatalogData>({
    domain: 'user',
    namespace: 'validationsErrors',
  })

export const {
  actions: mailboxValidationsErrorsActions,
  reducer: mailboxValidationsErrorsReducers,
} = generateCatalogSlice<ValidationsErrorsCatalogData>({
  domain: 'mailbox',
  namespace: 'validationsErrors',
})
